<template>
  <artisio-modal :visible="show" :title="title" body-class="qr-code-modal pb-3" size="sm" hide-footer
                 :content-in-form="false" @hidden="hideModal">
    <spinner :show="loading"/>
    <div class="data-wrapper" v-if="!loading">
      <div class="d-flex justify-content-center">
        <b-button variant="primary" @click="onPrintClick" style="flex:1" class="mr-1" :disabled="!base64">
          <font-awesome-icon icon="print" class="icon"/>
          {{ $t('Print') }}
        </b-button>
        <b-button variant="primary" @click="onDownloadClick" style="flex:1" class="ml-1" :disabled="!base64">
          <font-awesome-icon icon="download" class="icon"/>
          {{ $t('Download') }}
        </b-button>
      </div>
      <hr>
      <div class="pdf-content" v-html="content"></div>
      <iframe id="printContent" style="display: none;"></iframe>
    </div>
  </artisio-modal>
</template>

<script>
  import EventBus from "../../../plugins/event-bus";
  import {ON_QR_CODE_MODAL_OPEN, ON_QR_CODE_MODAL_DATA_RETRIEVE} from "@/plugins/event-bus/event-bus-names";
  import Spinner from "../common/Spinner";
  import ArtisioModal from "../artisio-modal/ArtisioModal";
  import QrCodeService from "@/core/components/qr-code-generator/QrCodeService";

  export default {
    name: "QrCodeModal",
    components: {ArtisioModal, Spinner},
    data() {
      return {
        loading: false,
        show: false,
        title: null,
        filename: null,
        content: null,
        base64: null
      }
    },
    methods: {
      hideModal() {
        this.title = null;
        this.show = false;
      },
      initData({base64, content, filename}) {
        this.loading = false;
        this.base64 = base64;
        this.content = content;
        this.filename = filename;
      },
      onDownloadClick() {
        const linkSource = `data:application/pdf;base64,${this.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = `${this.filename}.pdf`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      },
      onPrintClick() {
        let iframe = document.getElementById('printContent');
        let body = iframe.contentWindow.document.getElementsByTagName('body')[0];
        body.innerHTML = this.content;
        iframe.contentWindow.print()
      },
      async generateQrCode(uuid,type) {
        this.loading = true;
        let response = await QrCodeService.generateQrCode({
          model_type: type,
          model_uuid: uuid
        })

        if (response.success) {
          this.loading = false;
          this.base64 = response.body.base64;
          this.content = response.body.content;
        }
      }
    },
    beforeMount() {
      this.show = false;
      EventBus.$on(ON_QR_CODE_MODAL_OPEN, (data) => {
        this.title = data.title;
        this.show = true;
        this.loading = true;
        this.generateQrCode(data.uuid,data.type)
        if (data) {
          this.initData(data);
        }
      });
      EventBus.$on(ON_QR_CODE_MODAL_DATA_RETRIEVE, (data) => this.initData(data));
    },
    beforeDestroy() {
      EventBus.$off(ON_QR_CODE_MODAL_OPEN);
      EventBus.$off(ON_QR_CODE_MODAL_DATA_RETRIEVE);
    }
  }
</script>

<style lang="scss">
  .pdf-document {
    .items-table {
      td {
        &:first-child {
          overflow-wrap: anywhere;
        }
      }
    }
  }
</style>
